import { queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import { type ResCaseCategoriesQuery } from './types'

/**
 * @description
 *
 * This query is used to fetch case categories based on the case type.
 * If case type is not provided, it will return all case categories.
 */
export const caseCategoriesQuery = (caseType?: string) =>
  queryOptions<ResCaseCategoriesQuery>({
    queryKey: [API_ENDPOINTS.business['case-category'].index, caseType],
    queryFn: () => w.query({ caseType }).get(`${API_ENDPOINTS.business['case-category'].index}`).json(),
  })
